// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-deduction-payment.page.title': 'Team Member Deduction Payments',
    'team-member-deduction-payment.page.create.title': 'Create Deduction Payment',
    'team-member-deduction-payment.page.edit.title': 'Edit Team Member Deduction Payment',
    'team-member-deduction-payment.page.title.redo': 'Redo Payment',

    'team-member-deduction-payment.button.cancel': 'Cancel',
    'team-member-deduction-payment.button.void': 'Void Payment',
    'team-member-deduction-payment.button.create': 'Record Payment',
    'team-member-deduction-payment.button.new': 'Record Payment',
    'team-member-deduction-payment.button.save': 'Save Changes',
    'team-member-deduction-payment.button.edit': 'Edit',
    'team-member-deduction-payment.button.payments': 'Payment History',
    'team-member-deduction-payment.button.refund': 'Refund Payment',
    'team-member-deduction-payment.button.rollback': 'Rollback Payment',
    'team-member-deduction-payment.button.redo': 'Redo',

    'team-member-deduction-payment.placeholder.search': 'Search team member deduction payments',

    'team-member-deduction-payment.message.no_payment': 'No payment has been recorded as yet.',

    'team-member-deduction-payment.link.create_first_team_member_deduction_payment': 'Click here to create your first team member deduction payment',
    'team-member-deduction-payment.link.team_member_deduction_payments': ' Return to Team Member Deduction Payments',
    'team-member-deduction-payment.link.retry': 'Click here to retry',

    'team-member-deduction-payment.label.team_member_deduction_name': 'Team Member Deduction ',
    'team-member-deduction-payment.label.transaction_date': 'Transaction Date',
    'team-member-deduction-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'team-member-deduction-payment.label.is_reconciled': 'Is Reconciled',
    'team-member-deduction-payment.label.payment_method': 'Payment Method',
    'team-member-deduction-payment.label.reference_code': 'Reference Code',
    'team-member-deduction-payment.label.memo': 'Memo',
    'team-member-deduction-payment.label.currency_name': 'Currency',
    'team-member-deduction-payment.label.currency_amount_in_cents': 'Amount',
    'team-member-deduction-payment.label.cancelled_on': 'Cancelled On',
    'team-member-deduction-payment.label.cancellation_reason': 'Cancellation Reason',
    'team-member-deduction-payment.label.reason_for_void': 'Reason for voiding',
    'team-member-deduction-payment.label.rollback_reason': 'Reason for rollback',
    'team-member-deduction-payment.label.refund_reason': 'Reason for refund',

    'team-member-deduction-payment.sort.field_label': 'Field',
    'team-member-deduction-payment.sort.direction_label': 'Direction',
    'team-member-deduction-payment.sort.direction_ascending': 'Ascending',
    'team-member-deduction-payment.sort.direction_descending': 'Descending',

    'team-member-deduction-payment.modal.title.team_member_deduction_payment_delete_permanently': 'Delete Payment',
    'team-member-deduction-payment.modal.title.team_member_deduction_payment_restore': 'Restore Payment',
    'team-member-deduction-payment.modal.title.team_member_deduction_payment_void': 'Void Payment',
    'team-member-deduction-payment.modal.title.team_member_deduction_payment_refund': 'Refund Payment',
    'team-member-deduction-payment.modal.title.team_member_deduction_payment_rollback': 'Rollback Payment',

    'team-member-deduction-payment.success.message.team_member_deduction_payment_created': 'Your team member deduction payment has been recorded',
    'team-member-deduction-payment.success.message.team_member_deduction_payment_updated': 'Your team member deduction payment has been updated',
    'team-member-deduction-payment.success.message.team_member_deduction_payment_voided': 'Your team member deduction payment has been voided',
    'team-member-deduction-payment.success.message.team_member_deduction_payment_refunded': 'Your team member deduction payment has been refunded',
    'team-member-deduction-payment.success.message.team_member_deduction_payment_rolled_back': 'Your team member deduction payment has been rolled back',
    'team-member-deduction-payment.success.message.team_member_deduction_payment_redone': 'Your team member deduction payment has been redone',

    'team-member-deduction-payment.error.message.error_loading_page': 'Sorry, there was an error loading team member deduction payment.| Sorry, there was an error loading team member deduction payments.',
};
